import { ExpressionType_NormalRange } from '../_entity/expression/index.js';
import { capitalizeAllFirstLetters } from '@nu-art/ts-common';
export const Empty_NormalRangeExpression = (value, variable) => ({
    associatedVar: variable?._id,
    expressionType: ExpressionType_NormalRange.dbKey,
    terms: [],
    label: variable ? `${capitalizeAllFirstLetters(variable.name)} - Normal Range` : '',
    outputType: 'range',
    expression: value.data.declarationVarIds.length ? 'T1' : '[0,0]',
    isEvidenceBased: false,
    tagGroups: []
});
//# sourceMappingURL=consts.js.map